// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3JRHs","header":"Messages_header__TlxtM"};